
import React from "react";
// import Certificates from '../Components/Dashboard/Certificates/Certificates';
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Suspense, lazy } from 'react';
import SkeletonL from "../Components/Skeleton/Withlogin";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'

const Certificates = lazy(() => import('../Components/Dashboard/Certificates/Certificates'));
const AuthCertificates = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <Suspense fallback={<SkeletonL/>}>
  <Certificates/>
</Suspense> : <SessionTimeoutRedirect />
}
export default AuthCertificates;


